import { Refine } from "@refinedev/core";
import { useContextNotificationProvider } from "@/hooks/useContextNotificationProvider";

/**
 * Wrapper component that provides context-aware notifications to Refine.
 * Must be rendered inside AntApp to have access to the notification context.
 */
export const RefineWrapper = ({
  children,
  ...refineProps
}: { children: React.ReactNode } & React.ComponentProps<typeof Refine>) => {
  const notificationProvider = useContextNotificationProvider();

  return (
    <Refine {...refineProps} notificationProvider={notificationProvider}>
      {children}
    </Refine>
  );
};
